import { UserType } from '@avanta/shared/constants/users';

export const AcceptedUsers = [
  UserType.PATIENT,
  UserType.EMPLOYEE,
  UserType.PSYCHOLOGIST,
  UserType.SUPPORTER,
] as const;
